/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IPageTosData } from './page-tos.data';
import { IPageTosProps } from './page-tos.props.autogenerated';

export interface IPageTosViewProps extends IPageTosProps<IPageTosData> {

}

/**
 *
 * PageTos component
 * @extends {React.PureComponent<IPageTosProps<IPageTosData>>}
 */
class PageTos extends React.PureComponent<IPageTosProps<IPageTosData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default PageTos;
